<template>
  <div class="integration-monitoring-summary-cards">
    <v-card
      v-for="card in cards"
      :key="card.key"
      class="integration-monitoring-summary-card"
      :class="{
        'integration-monitoring-summary-card--compact-value': card.formatAsNumber === false,
        'integration-monitoring-summary-card--active': activeCard === card.key,
        'integration-monitoring-summary-card--inactive': activeCard && activeCard !== card.key,
      }"
      elevation="4"
      @click="onCardClick(card.key)"
    >
      <v-skeleton-loader
        v-if="loading"
        class="fill-width"
        type="list-item-avatar-two-line"
      />

      <template v-else>
        <div
          class="integration-monitoring-summary-card__icon"
          :style="{ backgroundColor: inactiveIconColor(card) }"
        >
          <v-icon color="white" size="24">
            {{ card.icon }}
          </v-icon>
        </div>

        <div class="integration-monitoring-summary-card__content">
          <div class="integration-monitoring-summary-card__value-row">
            <v-tooltip
              v-if="card.formatAsNumber === false && hasDisplayValue(card.value)"
              bottom
            >
              <template v-slot:activator="{ on, attrs }">
                <span
                  v-bind="attrs"
                  v-on="on"
                  class="integration-monitoring-summary-card__value"
                >
                  {{ formatValue(card.value, card.formatAsNumber) }}
                </span>
              </template>
              <span>{{ formatValue(card.value, false) }}</span>
            </v-tooltip>

            <span
              v-else
              class="integration-monitoring-summary-card__value"
            >
              {{ formatValue(card.value, card.formatAsNumber) }}
            </span>

            <span
              v-if="card.periodLabel"
              class="integration-monitoring-summary-card__period"
              :style="{ color: inactiveTextColor(card) }"
            >
              {{ card.periodLabel }}
            </span>
          </div>

          <span
            class="integration-monitoring-summary-card__label"
            :title="card.label"
          >
            {{ card.label }}
          </span>
        </div>
      </template>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'IntegrationMonitoringSummaryCards',
  props: {
    cards: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    activeCard: {
      type: String,
      default: null,
    },
  },
  methods: {
    onCardClick(key) {
      this.$emit('card-click', key);
    },
    isInactive(card) {
      return Boolean(this.activeCard && this.activeCard !== card.key);
    },
    inactiveIconColor(card) {
      return this.isInactive(card) ? 'var(--v-inactive-base)' : card.color;
    },
    inactiveTextColor(card) {
      return this.isInactive(card) ? 'var(--v-inactive-base)' : card.color;
    },
    hasDisplayValue(value) {
      return value !== null && value !== undefined && value !== '' && value !== '—';
    },
    formatValue(value, formatAsNumber = true) {
      if (value === null || value === undefined || value === '') {
        return '—';
      }

      if (formatAsNumber === false) {
        return value;
      }

      const numericValue = Number(value);
      if (Number.isNaN(numericValue)) {
        return value;
      }

      return new Intl.NumberFormat('pt-BR').format(numericValue);
    },
  },
};
</script>

<style lang="scss">
@import "@/shared/styles/integrationMonitoring/summary-cards.scss";
</style>
